import React, { type FC } from "react";

import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import {
  Flex,
  TEXT_VARIANT_BOLD_LIGHT,
  TEXT_VARIANT_LIGHT,
  Text,
  TooltipUtils,
} from "mailup-web-components";

import { stringOrDefault } from "Helpers/strings";

import RenderWhen from "Components/RenderWhen";
import type {
  ChannelSubscriptionStatus,
  SearchResult,
} from "Pages/RecipientsList/model";
import IconHelpBadge from "../../../../icons/iconHelpBadge.svg";
import { useRecoilState, useRecoilValue } from "recoil";
import { panelEditRecipientState } from "Pages/RecipientsList/recoil/state/recipient";

const StyledHelpIcon = styled.img`
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

const getStatusFilter = (tracking: boolean): string => {
  switch (tracking) {
    case true:
      return "brightness(0) saturate(100%) invert(62%) sepia(43%) saturate(600%) hue-rotate(108deg) brightness(90%)";
    default:
      return "brightness(0) saturate(100%) invert(52%)";
  }
};

interface TrackinkStatusDetailsProps {
  tracking: boolean;
}

const TrackinkStatusDetails: FC<TrackinkStatusDetailsProps> = ({
  tracking,
}) => {
  const intl = useIntl();

  const { trackingInsertDate, idNLFrom } = useRecoilValue(
    panelEditRecipientState,
  );

  return (
    <>
      <TooltipUtils
        id="tracking-status-details-tooltip"
        type="light"
        effect="solid"
        className="c-tooltip"
        place="bottom"
      >
        <Text variant="small-light">
          {trackingInsertDate
            ? intl.formatMessage(
                {
                  id: "Load.RecipientsList.TrackingStatusTooltip",
                },
                {
                  strong: (chunks) => <strong>{chunks}</strong>,
                  date: trackingInsertDate,
                  from:
                    idNLFrom === 0
                      ? intl.formatMessage({
                          id: "Load.RecipientsList.FromPlatform",
                        })
                      : intl.formatMessage({
                          id: "Load.RecipientsList.FromUsers",
                        }),
                },
              )
            : intl.formatMessage(
                {
                  id: "Load.RecipientsList.TrackingStatusTooltipNoDate",
                },
                {
                  strong: (chunks) => <strong>{chunks}</strong>,
                },
              )}
        </Text>
      </TooltipUtils>
      <StyledHelpIcon
        src={IconHelpBadge}
        alt=""
        style={{ filter: getStatusFilter(tracking) }}
        data-tip
        data-for="tracking-status-details-tooltip"
      />
    </>
  );
};

export default TrackinkStatusDetails;
